import { getPaymentOptionSlug } from "../shared/paymentOptions";

export function isKrwBankTransferDetailsOption(option, order) {
  if (!option || order?.fiat_money?.currency?.code !== "KRW") {
    return false;
  }

  if (getPaymentOptionSlug(option) !== "bank_transfer") {
    return false;
  }

  const d = option.details || {};
  return Boolean(d.recipient_name && d.account_number);
}

export function findKrwBankTransferOption(options, order) {
  if (!Array.isArray(options)) return null;
  return (
    options.find((option) => isKrwBankTransferDetailsOption(option, order)) ||
    null
  );
}

export function buildKrwBankDetailRows(option, order, t) {
  if (!isKrwBankTransferDetailsOption(option, order)) {
    return [];
  }

  const d = option.details || {};

  return [
    {
      key: "krw-recipient",
      label: t("krwRecipientName"),
      value: d.recipient_name || "—",
      rawValue: String(d.recipient_name || "").trim(),
    },
    {
      key: "krw-account",
      label: t("krwAccountNumber"),
      value: d.account_number || "—",
      rawValue: String(d.account_number || "").trim(),
    },
    {
      key: "krw-bank",
      label: t("krwBankName"),
      value: d.bank_name || "—",
      rawValue: String(d.bank_name || "").trim(),
    },
  ];
}
